/* Full screen for every content video on the site (product films, UGC, scene clips, gallery videos).
   A round button sits in the video's top-left corner; it plays the clip full screen with the player's own
   controls, and sound when the clip has it. Decorative loops are left alone: anything marked aria-hidden,
   inside a hero, or inside [data-no-fs]. Videos added later (galleries, explorers) are picked up too. */
(function () {
  'use strict';
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>';

  function skip(v) {
    return v.__fs || v.closest('[aria-hidden="true"], [data-no-fs], .ln-hero, .hero, [class*="__hero"]');
  }

  function load(v) {
    if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; v.load(); }
  }

  function enter(v) {
    load(v);
    v.__was = { controls: v.controls, muted: v.muted };
    v.controls = true;
    v.muted = false;
    var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
    if (v.requestFullscreen) v.requestFullscreen().catch(function () {});
    else if (v.webkitRequestFullscreen) v.webkitRequestFullscreen();
    else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen();
  }

  // back to how the clip was before (a silent loop stays a silent loop, a player keeps its controls)
  function leave(v) {
    if (!v.__was) return;
    v.controls = v.__was.controls; v.muted = v.__was.muted; v.__was = null;
  }

  function add(v) {
    if (skip(v)) return;
    v.__fs = true;
    var box = v.parentElement; if (!box) return;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'lk-fs'; b.innerHTML = ICON;
    b.setAttribute('aria-label', 'Play this video full screen');
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); enter(v); });
    box.appendChild(b);
    v.addEventListener('webkitendfullscreen', function () { leave(v); });
  }

  document.addEventListener('fullscreenchange', function () {
    if (document.fullscreenElement) return;
    document.querySelectorAll('video').forEach(leave);
  });

  function scan(root) { (root.querySelectorAll ? root.querySelectorAll('video') : []).forEach(add); }

  function init() {
    scan(document);
    new MutationObserver(function (list) {
      list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType !== 1) return; if (n.tagName === 'VIDEO') add(n); else scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
